import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface VoucherModel extends BaseModel {
  variables?: { [key: string]: string } | VoucherVariables
}

export interface VoucherVariables {
  VoucherParagraph: string;
  VoucherCtaText: string;
  VoucherImage: string;
  VoucherAlt: string;
  VoucherLink: string;
  VoucherHeading: string;
  VoucherText: string;
  VoucherLinkSegmentRegex: string;
}

export class VoucherInitVariables implements VoucherVariables {
  VoucherParagraph = '';
  VoucherCtaText = '';
  VoucherImage = '';
  VoucherAlt = '';
  VoucherLink = '';
  VoucherHeading = '';
  VoucherText = '';
  VoucherLinkSegmentRegex = '';
}

export class VoucherInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new VoucherInitVariables();
    this.variables = {...initVars};
    this.notifications = [new NotificationInitVariables()];
  }
}
